<template>
  <div class="subheader-container">{{text}}</div>
</template>

<script>
import arrowNav from "../icons/arrow-nav";

export default {
  name: "cms-subheader",
  props: ["text"]
};
</script>

<style scoped lang="scss">
.subheader-container {
  background-color: $white-two-color;
  text-align: center;
  color: $grey-five-color;  
  padding: .5rem;
}
</style>
